import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/queryClient";
import {
  getPOAStatementConsentsBankLink,
  submitPOADokobitConfirm,
  submitPOADokobitConsent,
  submitPOAServiceProviderRequests,
  submitUnderpermissionedExistingConsent,
} from "./services";

export const useGetPOAStatementConsentsBankLinkMutation = () =>
  useMutation({
    mutationFn: getPOAStatementConsentsBankLink,
  });

export const useSubmitPOAServiceProviderRequestsMutation = () =>
  useMutation({
    mutationFn: submitPOAServiceProviderRequests,
    onSuccess: () =>
      void queryClient.invalidateQueries({
        queryKey: ["powersOfAttorney", "serviceProviderRequests"],
      }),
  });

export const useSubmitPOADokobitConsentMutation = () =>
  useMutation({
    mutationFn: submitPOADokobitConsent,
  });

export const useSubmitPOADokobitConfirmMutation = () =>
  useMutation({
    mutationFn: submitPOADokobitConfirm,
    onSuccess: () =>
      void queryClient.invalidateQueries({
        queryKey: ["powersOfAttorney", "signedDocumentMetadata"],
      }),
  });

export const useSubmitUnderpermissionedExistingConsentMutation = () =>
  useMutation({
    mutationFn: submitUnderpermissionedExistingConsent,
  });
